import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-inline-block justify-content-center" }
const _hoisted_2 = { class: "material-symbols-outlined" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fontStyles.types, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-inline-block mx-1",
        key: index
      }, [
        (item.visible)
          ? (_openBlock(), _createBlock(_component_SelectButton, {
              key: 0,
              modelValue: _ctx.fontStyles.selectedOptions[index].options,
              "onUpdate:modelValue": ($event: any) => ((_ctx.fontStyles.selectedOptions[index].options) = $event),
              options: item.options,
              "aria-labelledby": "custom",
              multiple: item.multiSelect,
              onChange: _ctx.updateStyle
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(slotProps.option.icon), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "multiple", "onChange"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}